import type { App } from 'vue';
import type { ArcoIconOptions } from '../../_utils/types';
import _IconNoNetworkColor from './icon-no-network-color.vue';

const IconNoNetworkColor = Object.assign(_IconNoNetworkColor, {
  install: (app: App, options?: ArcoIconOptions) => {
    const iconPrefix = options?.iconPrefix ?? '';
    app.component(iconPrefix + _IconNoNetworkColor.name, _IconNoNetworkColor);
  }
});

export default IconNoNetworkColor;
